import { ArrowElbowRightDown, ArrowElbowRightUp } from "@phosphor-icons/react";
import clsx from "clsx";
import type React from "react";
import { match } from "ts-pattern";

export const GameLabel: React.FC<{
  children: string;
  direction?: "up" | "down";
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
}> = ({ children, direction = "down", position = "top-left" }) => {
  const Icon = match(direction)
    .with("up", () => ArrowElbowRightUp)
    .with("down", () => ArrowElbowRightDown)
    .exhaustive();
  return (
    <div
      className={clsx(
        "-mx-2 flex",
        match(position)
          .with("top-left", "bottom-left", () => "justify-start")
          .with("top-right", "bottom-right", () => "justify-end")
          .exhaustive(),
      )}
    >
      <div
        className={clsx(
          "absolute z-10 flex items-center gap-1 bg-base-100 px-2 text-sm",
          match(position)
            .with("top-left", "top-right", () => "top-0 -translate-y-1/2")
            .with(
              "bottom-left",
              "bottom-right",
              () => "bottom-0 translate-y-1/2",
            )
            .exhaustive(),
        )}
      >
        {children}
        <Icon className="size-4" weight="bold" />
      </div>
    </div>
  );
};
